import { BasicPage } from "../components/BasicPage";
import Person from "@mui/icons-material/Person";
import { apiFetch, useAuth } from "../hooks/useAuth";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Link as Link2, Navigate } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Link, ButtonGroup, Alert, Stack,
    Grid, Box, Button, FormControl,
    FormControlLabel, Checkbox,
    TextField, Typography, InputLabel, Select, MenuItem
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { FadingAlert } from "../components/FormFields";
import { sendEmailTemplate } from "../firebase";

import { useParams } from 'react-router';



export const UserPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();


    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors },
    } = useForm();


    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [accountid, setAccountID] = useState("");
    const [password, setPassword] = useState("");
    const [company, setCompany] = useState("");
    const [tenant, setTenant] = useState("");
    const [salutation, setSalutation] = useState("");
    const { token, claims } = useAuth();
    const [ediEnabled, setEdiEnabled] = useState(false);
    const [reqFields, setReqFields] = useState(false);
    const [crt, setCrt] = useState(false);
    const [sendActivationEmail, setSendActivationEmail] = useState(false);
    const [previousRole, setPreviousRole] = useState("");

    const onSubmit = data => {
        console.log("Submit with:", data);
        reset();
    };

    const handleSubmit2 = async (event) => {
        event.preventDefault();

        // const data = new FormData(event.currentTarget);
        setError("");

        var methodType, _id;

        if (id === "new") {
            methodType = "POST";
            _id = "";

        } else {
            methodType = "PATCH";
            _id = "/" + id;
        }

        const requestOptions = {
            method: methodType,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify({
                "displayName": displayName,
                "email": email,
                "password": password,
                "role": role,
                "accountid": accountid,
                "company": company,
                "tenant": tenant,
                "salutation": salutation,
                "edi": ediEnabled,
                "reqFields": reqFields,
                "crt": crt,
                "sendActivationEmail": sendActivationEmail
            })
        };
        console.log('Saving user with crt:', crt);
        console.log(requestOptions);

        apiFetch('/app/users' + _id, requestOptions)
            .then(response => response.json())
            .then(async data => {
                console.log(data);
                if (data.message) {
                    setError(data.message);
                } else {
                    setSuccess("Profil erfolgreich gespeichert.");

                    console.log("previousRole: ", previousRole);
                    console.log("role: ", role);
                    console.log("sendActivationEmail: ", sendActivationEmail);
                    // Send activation email if user was activated from inactive to User/Admin/Buyer
                    if (previousRole === "Inactive" && (role === "User" || role === "Admin" || role === "Buyer") && sendActivationEmail) {
                        try {
                            const emailData = {
                                template: "userActivation",
                                user: {
                                    name: displayName,
                                    email: email,
                                    cny: company,
                                    uid: id
                                },
                                form: {
                                    tenant: tenant,
                                    accountID: accountid,
                                    company: company,
                                    activationDate: new Date().toLocaleDateString('de-DE'),
                                    activationTime: new Date().toLocaleTimeString('de-DE')
                                },
                                currentYear: new Date().getFullYear(),
                            };
                            await sendEmailTemplate(emailData);
                            setSuccess("Profil erfolgreich gespeichert. Aktivierungs-E-Mail wurde versendet.");
                        } catch (emailError) {
                            console.error('Email sending failed:', emailError);
                            setSuccess("Profil erfolgreich gespeichert. Fehler beim Versenden der Aktivierungs-E-Mail.");
                        }
                    }
                    
                    // Update previous role for next comparison
                    setPreviousRole(role);
                    
                    // Reload user data to reflect updated custom claims (after small delay for propagation)
                    if (id !== "new") {
                        setTimeout(() => {
                            const reloadRequestOptions = {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + token,
                                },
                            };
                            apiFetch('/app/users/' + id, reloadRequestOptions)
                                .then(response => response.json())
                                .then(userById => {
                                    console.log('Reloaded user data:', userById);
                                    setCrt(userById?.customClaims?.crt || false);
                                    setEdiEnabled(userById?.customClaims?.edi || false);
                                    setReqFields(userById?.customClaims?.man || false);
                                })
                                .catch(err => console.error('Error reloading user:', err));
                        }, 500); // Wait 500ms for custom claims to propagate
                    }
                }
                // navigate("/dashboard/user");
            })
            .catch(error => {
                console.log(error);
                setError(error.message);
            });

    };


    const [loading, setLoading] = useState(false)
    const [data, setData] = useState("");


    useEffect(() => {

        if (id === "new") return;
        if (!token) return; // Wait for token to be available
        
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        };

        apiFetch('/app/users/' + id, requestOptions)
            .then(response => response.json())
            .then(userById => {
                console.log(userById);
                setDisplayName(userById.displayName)
                setEmail(userById.email)
                const currentRole = userById?.customClaims?.role;
                setRole(currentRole)
                setPreviousRole(currentRole)
                setAccountID(userById?.customClaims?.aid)
                setPassword("");
                setCompany(userById?.customClaims?.cny);
                setTenant(userById?.customClaims?.tnt);
                setSalutation(userById?.customClaims?.son);
                setEdiEnabled(userById?.customClaims?.edi || false);
                setReqFields(userById?.customClaims?.man || false);
                setCrt(userById?.customClaims?.crt || false);
                setSendActivationEmail(userById?.customClaims?.sendActivationEmail || false);

            });

    }, [id, token]);

    return (

        <>
            < BasicPage title={id === "new" ? "Profil anlegen" : "Profil ändern"} icon={< Person />} >

                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box component="form" onSubmit={handleSubmit2}
                        // minWidth={'600px'}
                        sx={{
                            mt: 3,
                            width: '100%', // Fix IE 11 issue.
                            maxWidth: '600px',
                        }}>
                        {/* <form onSubmit={handleSubmit(onSubmit)}> */}

                        <Stack spacing={2}>

                            <TextField
                                name="tenant"
                                required
                                fullWidth
                                id="tenant"
                                label="Mandant"
                                value={tenant}
                                onChange={(e) => setTenant(e.target.value)}
                            // autoFocus
                            />

                            <TextField
                                name="company"
                                required
                                fullWidth
                                id="company"
                                label="Institution / Firma"
                                value={company}
                                onChange={(e) => setCompany(e.target.value)}
                            // autoFocus
                            />

                            <FormControl>
                                <InputLabel id="salutation-label">Anrede</InputLabel>
                                <Select
                                    labelId="salutation-label"
                                    id="salutation"
                                    value={salutation}
                                    label="Anrede"
                                    onChange={(e) => setSalutation(e.target.value)}
                                >
                                    <MenuItem value="Herr">Herr</MenuItem>
                                    <MenuItem value="Frau">Frau</MenuItem>
                                    <MenuItem value="Dr.">Dr.</MenuItem>
                                    <MenuItem value="Prof.">Prof.</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                name="displayName"
                                required
                                fullWidth
                                id="displayName"
                                label="Vor- und Nachname"
                                value={displayName}
                                onChange={(e) => setDisplayName(e.target.value)}

                            />


                            <TextField
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="email"
                            />

                            <TextField

                                fullWidth
                                name="password"
                                label="Passwort"
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="new-password"
                            />

                            <TextField
                                required
                                fullWidth
                                id="accountid"
                                label="Kunden-Nr."
                                name="accountid"
                                value={accountid}
                                onChange={(e) => setAccountID(e.target.value)}
                                autoComplete=""
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={ediEnabled}
                                        onChange={(e) => setEdiEnabled(e.target.checked)}
                                        name="edi"
                                    />
                                }
                                label="EDI Format für Emails aktivieren"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={reqFields}
                                        onChange={(e) => setReqFields(e.target.checked)}
                                        name="reqFields"
                                    />
                                }
                                label="Pflichtfelder aktivieren"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={crt}
                                        onChange={(e) => setCrt(e.target.checked)}
                                        name="crt"
                                    />
                                }
                                label="Kundenspezifische Warenkorb-Felder aktivieren"
                            />


                            <FormControl fullWidth>
                                <InputLabel id="userrole-select-label">Benutzerrechte</InputLabel>
                                <Select
                                    labelId="userrole-select-label"
                                    id="role"
                                    name="role"
                                    value={role}
                                    label="Benutzerrechte"
                                    onChange={(e) => setRole(e.target.value)}
                                >
                                    <MenuItem value="SuperAdmin">SuperAdmin</MenuItem>
                                    <MenuItem value="Admin">Admin</MenuItem>
                                    <MenuItem value="User">User (mit Status-Zugriff)</MenuItem>
                                    <MenuItem value="Buyer">Buyer (nur Bestellungen)</MenuItem>
                                    <MenuItem value="Inactive">Inactive</MenuItem>
                                </Select>
                            </FormControl>

                            {previousRole === "Inactive" && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={sendActivationEmail}
                                            onChange={(e) => setSendActivationEmail(e.target.checked)}
                                            name="sendActivationEmail"
                                        />
                                    }
                                    label="Schicke Nutzer eine Email, wenn er aktiviert wird"
                                />
                            )}

                            {error && <Alert severity="error">{error}</Alert>}
                            {success && <Alert severity="success">{success}</Alert>}

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                            >
                                {id === "new" ? "Anlegen" : "Ändern"}
                            </Button>

                            <Button
                                onClick={() => navigate("/web/user")}
                            >   Zurück
                            </Button>

                        </Stack>

                    </Box>
                </Grid>

            </BasicPage>

        </>
    );
};

